import { request } from './http';

export interface CourseResponse {
	id: number;
	subjectId: number;
	subjectName: string;
	code: string;
	resourceCount: number;
	studentCount: number;
	hasChangesRequested: boolean;
	createdAt: string;
}

export const listTeacherCourses = (): Promise<CourseResponse[]> => request('/api/teacher/courses');

export const claimCourse = (subjectId: number): Promise<CourseResponse> =>
	request('/api/teacher/courses', {
		method: 'POST',
		body: JSON.stringify({ subjectId }),
	});

export const regenerateCourseCode = (id: number): Promise<CourseResponse> =>
	request(`/api/teacher/courses/${id}/regenerate-code`, { method: 'POST' });

export const releaseCourse = (id: number): Promise<void> =>
	request(`/api/teacher/courses/${id}`, { method: 'DELETE' });
